import { h } from "preact";
import { Select, Tag, Typography } from 'antd';
import { COUNTRIES } from '../constants/countries.js';

const { Text } = Typography;
const { Option } = Select;

const CountrySelector = ({ settings, onSettingChange, disabled = false }) => {
    const isConfigured = settings.allowed_countries !== null;

    if (!isConfigured) {
        return (
            <div style={{ marginTop: '12px' }}>
                <Text type="secondary" style={{
                    fontSize: '12px',
                    fontStyle: 'italic',
                    color: disabled ? '#ccc' : '#ff7a00'
                }}>
                    Country blocking is not configured. Toggle the switch above to enable and configure allowed countries.
                </Text>
            </div>
        );
    }

    return (
        <div style={{ marginTop: '12px' }}>
            <Text strong style={{
                display: 'block',
                marginBottom: '8px',
                color: disabled ? '#999' : 'inherit'
            }}>
                Allowed Countries
            </Text>
            <Select
                mode="multiple"
                placeholder="Select countries to allow access"
                value={Array.isArray(settings.allowed_countries) ? settings.allowed_countries : []}
                onChange={(value) => onSettingChange('allowed_countries', value)}
                style={{ width: '100%' }}
                size="large"
                disabled={disabled}
                showSearch
                filterOption={(input, option) => {
                    const country = COUNTRIES.find(c => c.code === option.value);
                    if (!country) return false;

                    const searchText = input.toLowerCase();
                    return (
                        country.name.toLowerCase().includes(searchText) ||
                        country.code.toLowerCase().includes(searchText) ||
                        country.name.toLowerCase().startsWith(searchText) // Prioritize starts with
                    );
                }}
            >
                {COUNTRIES.map(country => (
                    <Option key={country.code} value={country.code}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span>{country.flag}</span>
                            <span>{country.name}</span>
                            <Tag size="small">{country.code}</Tag>
                        </div>
                    </Option>
                ))}
            </Select>
            <Text type="secondary" style={{
                fontSize: '12px',
                marginTop: '8px',
                display: 'block',
                color: disabled ? '#ccc' : 'inherit'
            }}>
                Users from selected countries will be allowed to access verification services.
                All other countries will be blocked.
            </Text>
        </div>
    );
};

export default CountrySelector;
